import StyledAddButton from '../../TextField/TextViewer/AddButton/StyledAddButton';
import { FormattedMessage } from 'react-intl';
import useIsPortfolioReadonly from '@/components/ChallengePortfolio/NormalView/useIsPortfolioReadonly';

type AddLogEntryButtonProps = {
  logEntryName: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const AddLogEntryButton = ({
  logEntryName,
  onClick,
}: AddLogEntryButtonProps) => {
  const portfolioIsReadonly = useIsPortfolioReadonly();

  return (
    <StyledAddButton
      onClick={!portfolioIsReadonly ? onClick : undefined}
      disabled={portfolioIsReadonly}
    >
      <FormattedMessage
        id="portfolio.challenge.log_entries.add.button"
        values={{ logEntryName }}
      />
    </StyledAddButton>
  );
};

export default AddLogEntryButton;
